import { render } from "./MediaflowDestinationCard.vue?vue&type=template&id=35f834f9"
import script from "./MediaflowDestinationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowDestinationCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Mediaflow/MediaflowDestinationCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35f834f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35f834f9', __exports__)) {
    api.reload('35f834f9', __exports__)
  }
  
  module.hot.accept("./MediaflowDestinationCard.vue?vue&type=template&id=35f834f9", () => {
    api.rerender('35f834f9', render)
  })

}


export default __exports__